import { IOnInit, IPromise } from "angular";
import {
  FormViewController,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../../../../../records/forms/formView";
import fieldHelpers from "../../../../../../ui-formly/fieldHelpers";
import { StateService } from "@uirouter/angularjs";
import { RecordFileTemplateOptions } from "../../../../../../records/forms/formly/types";
import { Machine } from "../../../../models/machine";
import { IFieldArray } from "AngularFormly";
import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../../../../records/forms/formly/fieldConfigurationHelpers";
import * as lookupNames from "../../../../configs/lookup";
import { LookupManagementService } from "../../../../../../records/lookup/lookupManagement";
import { vsLookupManagementServiceName } from "../../../../../shared/lookups";
import {
  ChangeJournalModalService,
  vsServiceName as ChangeJournalModalServiceName,
} from "../../../../../../records/changeJournal/changeNoteModalService";


export class SingleMachineMoveComponentController implements IOnInit {
  static $inject = [
    FormViewServiceName,
    "$state",
    FieldConfigurationHelperServiceName,
    vsLookupManagementServiceName,
    ChangeJournalModalServiceName
  ];
  readonly formFields: IFieldArray;
  model: any;
  /* start bindings */
  readonly machine!: Machine;
  /* end binding */

  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService,
    fieldConfigurationHelperService: FieldConfigurationHelperService,
    private readonly lookupManagementService: LookupManagementService,
    private readonly changeJournalModalService: ChangeJournalModalService
  ) {
    const fileTemplateOptions: RecordFileTemplateOptions = {
      allowMultiple: true,
      label: "Files",
    };
    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleDateField({
            key: "Date",
            name: "Date",
            label: "Change Date",
            required: true,
            
          }),
        ],
        4
      ),
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleStringField({
            key: "SlotNumber",
            className: "col-xs-3",
            label: "Machine Number",
            required: true,
            expressionProperties: {
              "templateOptions.helpText": this.previousText(),
            },
          }),
          fieldConfigurationHelperService.lookupField(lookupManagementService, {
            key: "MachineSectionId",
            label: "Section",
            required: true,
            objectName: lookupNames.sectionName,
            hideAddButton: true,
            expressionProperties: {
              "templateOptions.helpText": this.previousText(),
            },
          }),
          fieldHelpers.simpleStringField({
            key: "Bank",
            name: "Bank",
            label: "Bank",
            required: true,
            expressionProperties: {
              "templateOptions.helpText": this.previousText(),
            },
          }),
          fieldHelpers.simpleStringField({
            key: "Position",
            name: "Position",
            label: "Position",
            required: true,
            expressionProperties: {
              "templateOptions.helpText": this.previousText(),
            },
          }),
        ],
        4
      ),
      {
        key: "Files",
        name: "Files",
        type: "recordFileUpload",
        templateOptions: fileTemplateOptions,
      },
      fieldHelpers.headerField({
        headerText: "Notes",
        key: "NotesHeader",
      }),
      fieldHelpers.textAreaField({
        key: "Notes",
        name: "Notes",
        label: " ",
        rows: 5,
      }),
    ];
  }

  $onInit(): void {
    const currentConfiguration = this.machine.Configs?.find(
      (c) => c.CurrentConfiguration
    );
    this.model = {
      MachineId: this.machine.Id,
      SlotNumber: currentConfiguration?.SlotNumber ?? undefined,
      Files: currentConfiguration?.Files?.map((f: any) => {
        return { Name: f.Name, ContentType: f.ContentType, Url: f.Url };
      }),
    };
  }

  submit(formViewController: FormViewController): IPromise<void> {
    const machineId = this.machine.Id;
    return this.changeJournalModalService
      .getAndSetChangeJournalNote(this.model)
      .then(() =>
        this.formViewService.submitForm({
          url: `/api/machines/${machineId}/move`,
          formObject: this.model,
          formViewController,
          method: "post",
        })
      )
      .then(() => {
        this.$state.go("^", undefined, { reload: true });
      });
  }

  cancel(): Promise<void> {
    return this.$state.go("^").then(() => {});
  }

  private previousText(fieldSelector?: (view: any) => any) {
    return (_: any, __: any, scope: any) => {
      const currentConfiguration = this.machine.Configs?.find(
        (c) => c.CurrentConfiguration
      );
  
      if (!currentConfiguration) return undefined;
  
      fieldSelector ??= (view) =>
        view ? view[scope.options.key] : undefined;
  
      const value = fieldSelector(currentConfiguration);
      return value ? `Previous: ${value}` : undefined;
    };
  }
  
  

  
}
